import { Component, Input, OnInit } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { Store } from '@ngrx/store';
import { AppState } from '@shared/redux/config-store-state.model';
import { emitAlert } from '@shared/redux/actions/actions-store-state.model';
import { AuthorRoleService } from '@shared/services/author-role.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'astrea-magazines-details',
  templateUrl: './magazines-details.component.html',
  styleUrls: ['../../../doctrine/components/doctrine-details/doctrine-details.component.scss']
})
export class MagazinesDetailsComponent implements OnInit {

  @Input() magazine!: any;
  public loadingFile = false;
  public authors: any = [];

  constructor(
    private _t: TranslateService,
    private store: Store<AppState>,
    private authorRoleService: AuthorRoleService,
    private sanitizer: DomSanitizer,
  ) { }

  ngOnInit(): void {
    this.buildAuthorsData();
  }

  buildAuthorsData(): void {
    const authorsData = this.authorRoleService.buildAuthorsAndRoles(this.magazine.authors, this.magazine.vAuthor);
    this.authors = authorsData.slice(0, 3);
  }

  getAstreaVirtualURL() {
    return this.sanitizer.bypassSecurityTrustUrl(`https://astreavirtual.com/reader/${this.magazine.bookcode}`);
  }

  alertFileError(): void {
    this.store.dispatch(emitAlert({
      message: this._t.instant('alert.file_err'),
      alertType: 'danger'
    }));
  }

}
